module.exports = __webpack_public_path__ + "assets/img/logo-alt-sm.de52167a.png";